import React from 'react';
import {Outlet} from "react-router-dom";

const Producer: React.FC = () => {
  return (
    <Outlet/>
  );
};

export default Producer;